// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2XPgR","file":"styles_file__2h3SV"};